let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7m77a")).then(() => parcelRequire('lrS2i'));